// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  locks: [],
  unlocks: [],
}

export const mutations = {
  SET_LOCKS(state, locks) {
    state.locks = locks
  },
  SET_UNLOCKS(state, unlocks) {
    state.unlocks = unlocks
  },
}

export const actions = {
  fetchLocks({ commit }, payload) {
    return ApiService.fetchLocks(payload)
      .then((res) => {
        const locks = res.data.data
        commit('SET_LOCKS', locks)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchLock({ commit }, payload) {
    return ApiService.fetchLock(payload)
      .then((res) => {
        const locks = res.data.data
        return locks
      })
      .catch((error) => {
        throw error
      })
  },
  fetchUnlocks({ commit }, payload) {
    return ApiService.fetchUnlocks(payload)
      .then((res) => {
        const unlocks = res.data.data
        commit('SET_UNLOCKS', unlocks)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchUnlock({ commit }, payload) {
    return ApiService.fetchUnlock(payload)
      .then((res) => {
        const unlocks = res.data.data
        return unlocks
      })
      .catch((error) => {
        throw error
      })
  },
  editLock({ commit }, payload) {
    return ApiService.editLock(payload)
      .then((res) => {
        const lock = res.data
        return lock
      })
      .catch((error) => {
        throw error
      })
  },
  editUnlock({ commit }, payload) {
    return ApiService.editUnlock(payload)
      .then((res) => {
        const unlock = res.data
        return unlock
      })
      .catch((error) => {
        throw error
      })
  },
}

export const getters = {}
